import React, { useEffect, useState } from "react";
import ThemeProvider from "./provider/ThemeProvider";
import HomeStack from "./HomeStack";
import { BaseAuthContainer } from "./BaseAuthContainer";
import LoadingScreen from "./components/LoadingScreen";
import { useAppDispatch, useAppSelector } from "./redux/store";
import { logOutAction } from "./redux/slices/authSlice";
import i18n from "./i18n";
import AuthStack from "./screens/auth/AuthStack";

export default function RootNavigator() {
  const dispatch = useAppDispatch();
  const language = useAppSelector((state) => state.auth.language);

  // Handle language changes
  useEffect(() => {
    void i18n.changeLanguage(language);
  }, [language]);

  // User data listening moved to HomeStack

  const handleUserUpdate = async (firebaseUser: any) => {
    // setAuthenticated(true);
  };

  const handleUserLogout = () => {
    // setAuthenticated(false);
    dispatch(logOutAction());
  };

  return (
    <ThemeProvider>
      <BaseAuthContainer
        loadingComponent={LoadingScreen}
        authComponent={AuthStack}
        onUserUpdate={handleUserUpdate}
        onUserLogout={handleUserLogout}
      >
        <HomeStack />
      </BaseAuthContainer>
    </ThemeProvider>
  );
}
